export default {
  name: 'patch-management',
  translationKey: 'patch-management-module',
  routePrefix: 'patch-management',
  routeNamePrefix: 'admin.patch-management',
  directRoutesAvailable: false,
}
